import React from 'react';

import {
    ToggleSwitch,
    InputGroupPre,
} from '../../../Form';
import { getEventCurrencySymbol } from '../../../../utils/events';

const PrizeMoney = (props) => {
    const {
        field,
        value,
        formApi,
        prizeMoneyField,
        currency,
        allowOffPlatformPayments,
    } = props;

    const validatePrizeMoney = (val, currencySymbol) => ({
        error: !val || (val && /^\d+$/.test(val) && val > 0) ? null : `Prize money should be more than ${currencySymbol}0 (whole number).`,
    });

    return (
        <div className={`col-12 mb24`}>
            <div className="div div16" />
            <ToggleSwitch
                id={'hasPrizeMoney'}
                field={field}
                formGroupCssClass={`mt16`}
                label="Is this a prize money event?"
                data-testid="event-edit.prize-money.toggle"
                onChange={(val) => {
                    if (!val) {
                        formApi.setValue('prizeMoney', null);
                    }
                }}
                reverse={false}
            />
            {value && (
                <div className={`d-flex align-items-start`}>
                    <div className={`flex-2`}>
                        <div className={`form-group form-group-xl mt16`}>
                            <label htmlFor={'verified'} data-testid="prizemoney.label-43">
                                {'Amount of Prize Money'}
                            </label>
                        </div>
                    </div>
                    <div className={`flex-1`}>
                        <InputGroupPre
                            id={`prizeMoney`}
                            hiddenLabel={true}
                            field={prizeMoneyField}
                            type="number"
                            pre={getEventCurrencySymbol(allowOffPlatformPayments, currency)}
                            placeholder="Ex. 45"
                            validate={values => validatePrizeMoney(values, currency.currencySymbol)}
                            className="hide-spinner"
                            data-testid="event-edit.prize-money-input"
                        />
                    </div>
                </div>
            )}
            <div className="div div16" />
        </div>
    );
};

export default PrizeMoney;
